import React, { useEffect, useState } from 'react'
import "./navBar.css"
import Button from '@mui/material/Button';
import useWindowDimensions from '../../customHooks/useWindowDimensions';

import { Link, useNavigate } from "react-router-dom";
import PopUp from '../../components/popUp/PopUp';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import BookNowBtn from '../../components/bookNowBtn/BookNowBtn';
import { useDispatch, useSelector } from 'react-redux';
import { removeLoginFlg, updateLoginFlg } from '../../redux/features/login/loginSlice';
import LoginForm from '../../components/loginForm/LoginForm';
import Disclaimer from '../../components/disclaimer/Disclaimer';

// TYPE 1 = Langing Page
// TYPE 2 = Home

function CondComp({ comp }) {
    if (comp === "signup") return <p>Need Data</p>
    else if (comp === "login") return <LoginForm />
    else if (comp === "disclmer") return <Disclaimer />
}

function Navbar({ type }) {
    const navigate = useNavigate()
    // const [logInFlg, setLogInFlg] = useState(sessionStorage.getItem("logInFlg"))
    const isLogin = useSelector(state => state.login?.isLogin)
    const dispatch = useDispatch()

    const [popUpState, set_popUpState] = useState({
        open: false,
        comp: "",
        title: "",
        footerFlg: false
    })
    const { height, width } = useWindowDimensions();
    const [navBarToggle, set_navBarToggle] = useState(false)
    const [currentSelection, set_currentSelection] = useState(0)
    useEffect(() => {
        console.log(width);
    }, [width])


    const handle_NavBarToggle = () => {
        set_navBarToggle(!navBarToggle)
    }

    const scrollToSection = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    };

    const handleLogOut = () => {
        dispatch(removeLoginFlg())
        navigate("/")
    }

    const handleOpenPopup = (comp="",footerFlg=false,title="",) => {
        set_popUpState({
            open: true,
            comp: comp,
            title: title,
            footerFlg: footerFlg
        })

    }

    return (
        <div className={"Navbar" + ((width <= 1200 && !navBarToggle) ? " mob-Navbar" : "")}>
            <div className='nav-brand'>
                <span onClick={() => navigate("/")}>
                    <img className='brand-logo' src="../../../img/brand_logo.webp" />
                </span>
                {width <= 1200 ?
                    <div className='toggle-btn' onClick={handle_NavBarToggle}>
                        {navBarToggle ? <span className="material-symbols-outlined nav-menu-icon">
                            close
                        </span> :
                            <span className="material-symbols-outlined nav-menu-icon">
                                menu
                            </span>}

                    </div>
                    : ""}
            </div>
            {/* <div className='content'> */}
            <div className={"nav-tabs"}>
                <span
                    className={currentSelection === 0 ? "darkBlue" : "lightBlue"}
                    onClick={() => navigate("/")}>
                    Home
                </span>

                {(type === 1 || type === 2 ) && <span
                    className={currentSelection === 1 ? "darkBlue" : "lightBlue"}
                    onClick={() => {
                        isLogin ? 
                        navigate("/dashboard") : 
                        handleOpenPopup("login",true,"")
                    }}>
                    Dashboard
                </span>}

                {type === 1 && <span
                    className={currentSelection === 4 ? "darkBlue" : "lightBlue"}
                    onClick={() => scrollToSection("faqSection")}>
                    FAQ's
                </span>}

                {type === 1 && <span
                    className={currentSelection === 4 ? "darkBlue" : "lightBlue"}
                    onClick={() => scrollToSection("testimonialSection")}>
                    Testimonials
                </span>}

                {(type === 1 && !isLogin) && <span
                    className={currentSelection === 4 ? "darkBlue" : "lightBlue"}
                    onClick={() => handleOpenPopup("login",true,"")}>
                    Log in
                </span>}

                {isLogin && <span
                    className={currentSelection === 0 ? "darkBlue" : "lightBlue"}
                    onClick={() => navigate("/receipt")}>
                    Receipt
                </span>}

                {(isLogin) && <span
                    className={currentSelection === 0 ? "darkBlue" : "lightBlue"}
                    onClick={handleLogOut}>
                    Log Out
                </span>}


                {/* <Link target='_blank' to={"https://vaanyam-admin.web.app"}>
                <span>
                    Admin
                </span>
            </Link> */}
            </div>
            <div className='nav-contactBtn-wp'>

                {isLogin ? 
                <Button onClick={()=>handleOpenPopup("disclmer")} className='nav-contactBtn' >
                    <span className='no-line-break'>
                        Disclaimer
                    </span>
                </Button> : 
                <BookNowBtn />
                }
            </div>

            <PopUp 
                titleStyle={{ fontSize: "1.5rem" }} 
                title={popUpState?.title} 
                open={popUpState.open}
                showFooter={popUpState?.footerFlg} 
                onClose={() => {
                    set_popUpState({ open: false, comp: "", title: "", footerFlg: false });
                    set_currentSelection(-1)
                }} >
                <CondComp comp={popUpState.comp} />
            </PopUp>
        </div>
    )
}

export default Navbar